import _regeneratorRuntime from 'babel-runtime/regenerator';
import { GaiaApolloClient } from '../gaia-data/apolloClient';
import { TutoringNextSessionStartTimeQuery, TutoringSchedulerLaunchInfoQuery } from './apollo/tutoring-graphql';

export function getNextTutoringSessionTime() {
  var data;
  return _regeneratorRuntime.async(function getNextTutoringSessionTime$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return _regeneratorRuntime.awrap(GaiaApolloClient.query({
            query: TutoringNextSessionStartTimeQuery
          }));

        case 2:
          data = _context.sent;
          return _context.abrupt('return', data.data);

        case 4:
        case 'end':
          return _context.stop();
      }
    }
  }, null, this);
}

export function loadTutoringSchedulerLaunchInfo() {
  var data;
  return _regeneratorRuntime.async(function loadTutoringSchedulerLaunchInfo$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return _regeneratorRuntime.awrap(GaiaApolloClient.query({
            query: TutoringSchedulerLaunchInfoQuery
          }));

        case 2:
          data = _context2.sent;
          return _context2.abrupt('return', data.data);

        case 4:
        case 'end':
          return _context2.stop();
      }
    }
  }, null, this);
}